import { MdClose, MdDeleteOutline, MdModeEditOutline, MdSave } from "react-icons/md";
import { Grid, Loader, Table } from "semantic-ui-react";
import { InputNumber } from "../../../../components/InputText/InputNumber";
import { CULTIVATION_LABEL_TYPE } from "../../../../config/constants";

export function renderTableHeader() {
  return (
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell className="tableHeader" colSpan="2" textAlign="center">
          Cultivation
        </Table.HeaderCell>
        <Table.HeaderCell
          className="tableHeader"
          colSpan="14"
          textAlign="center"
          style={{ backgroundColor: "#f4c6db", color: "#000" }}
        >
          Input field
        </Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.HeaderCell className="tableHeaderReview">Cultivation Name</Table.HeaderCell>
        <Table.HeaderCell className="tableHeaderReview">Data type</Table.HeaderCell>
        <Table.HeaderCell className="tableHeaderReview">Product Type</Table.HeaderCell>
        <Table.HeaderCell className="tableHeaderReview">Original Country</Table.HeaderCell>
        <Table.HeaderCell className="tableHeaderReview">Harvest Year</Table.HeaderCell>
        <Table.HeaderCell className="tableHeaderReview">Growth Area</Table.HeaderCell>
        <Table.HeaderCell className="tableHeaderReview">Harvest yield</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
  );
}

export function editDataRow(
  label: string,
  item: any,
  selectedCultivation: any,
  currentFormData: any,
  handleSubmit: any,
  saveFertilizerPesticideData: any,
  setSelectedCultivation: any,
  setValue: any,
  control: any,
  errors: any,
  isCultivationFormFieldDataMutateLoading: boolean,
  setViewModal: any,
  reset: any,
  isEditable: any
) {
  const isSave = item?.id === selectedCultivation?.id && item?.ownId === selectedCultivation?.ownId;
  if (label === CULTIVATION_LABEL_TYPE.GenericUser) {
    return item?.yieldValue;
  }
  if (label !== CULTIVATION_LABEL_TYPE.Fertilizer && label !== CULTIVATION_LABEL_TYPE.Pesticide) {
    return null;
  }

  const updateList = (list: any[], itemId: number | string, quantityKey: string, value: any) => {
    const quantity = Number(value);
    if (Number.isNaN(quantity)) return list;

    return list.map(item => (item.id === itemId ? { ...item, [quantityKey]: quantity } : item));
  };

  const handleSave = () => {
    handleSubmit((data: any) => {
      let fertilizerList = currentFormData?.cultivationField?.fertilizerList || [];
      let pesticideList = currentFormData?.cultivationField?.pesticideList || [];

      if (label === CULTIVATION_LABEL_TYPE.Fertilizer) {
        fertilizerList = updateList(
          fertilizerList,
          selectedCultivation.id,
          "fertilizerQuantity",
          data.fertilizerQuantity
        );
      }

      if (label === CULTIVATION_LABEL_TYPE.Pesticide) {
        pesticideList = updateList(
          pesticideList,
          selectedCultivation.id,
          "pesticideQuantity",
          data.pesticideQuantity
        );
      }

      saveFertilizerPesticideData(fertilizerList, pesticideList);
    })();
  };

  const handleEdit = () => {
    setSelectedCultivation(item);
    if (label === CULTIVATION_LABEL_TYPE.Fertilizer) {
      setValue("fertilizerQuantity", item?.fertilizerQuantity ?? "");
    } else if (label === CULTIVATION_LABEL_TYPE.Pesticide) {
      setValue("pesticideQuantity", item?.pesticideQuantity ?? "");
    }
  };

  const handleDelete = () => {
    setSelectedCultivation(item);
    setViewModal(true);
  };

  const handleCancel = () => {
    setSelectedCultivation(null);
    reset();
  };

  return (
    <Grid>
      <Grid.Column computer={4} tablet={5} mobile={5}>
        {isCultivationFormFieldDataMutateLoading && isSave ? (
          <Loader active size="small" inline="centered" />
        ) : isSave ? (
          <MdSave
            cursor="pointer"
            size={24}
            color="var(--tableEditIcon)"
            title="Save"
            onClick={handleSave}
          />
        ) : (
          <>
            {isEditable && (
              <MdModeEditOutline
                cursor="pointer"
                size={24}
                color="var(--tableEditIcon)"
                onClick={handleEdit}
              />
            )}
          </>
        )}
      </Grid.Column>
      {!(isCultivationFormFieldDataMutateLoading && isSave) ? (
        isSave ? (
          <Grid.Column computer={4} tablet={5} mobile={5}>
            <MdClose
              cursor={"pointer"}
              size={24}
              color="var(--tableEditIcon)"
              onClick={handleCancel}
            />
          </Grid.Column>
        ) : (
          <Grid.Column computer={4} tablet={5} mobile={5}>
            {isEditable && (
              <MdDeleteOutline
                cursor={"pointer"}
                size={24}
                color="var(--tableEditIcon)"
                onClick={handleDelete}
              />
            )}
          </Grid.Column>
        )
      ) : null}
    </Grid>
  );
}

export const getItemQuantity = (
  item: any,
  selectedCultivation: any,
  control: any,
  errors: any
): any => {
  const isEditing =
    item?.id === selectedCultivation?.id && item?.ownId === selectedCultivation?.ownId;
  const quantityFieldName =
    item?.label === CULTIVATION_LABEL_TYPE.Fertilizer
      ? "fertilizerQuantity"
      : item?.label === CULTIVATION_LABEL_TYPE.Pesticide
      ? "pesticideQuantity"
      : null;

  if (isEditing && quantityFieldName) {
    return (
      <InputNumber
        transform={{
          input: (value: any) =>
            value === null || value === undefined || isNaN(value) ? "" : value.toString(),
          output: (e: any) => e
        }}
        control={control}
        placeholder="kg/ha"
        name={quantityFieldName}
        errors={errors?.[quantityFieldName]}
        required
        errorMessage="Quantity is required"
      />
    );
  }
  switch (item?.label) {
    case CULTIVATION_LABEL_TYPE.GenericUser:
      return item?.value ?? 0;
    case CULTIVATION_LABEL_TYPE.Fertilizer:
      return item?.fertilizerQuantity ?? 0;
    case CULTIVATION_LABEL_TYPE.Pesticide:
      return item?.pesticideQuantity ?? 0;
    default:
      return item?.value ?? 0;
  }
};
